import type { ActiveAnalysisQuantityValue } from "../../../api/useActiveAnalysesStream";

const SIGMA_COUNT = 2;

function isSymptom(
  quantityValue: ActiveAnalysisQuantityValue,
  offset: number,
  sigmaDiagnosis: number | null,
) {
  const { measured, simulated } = quantityValue;
  if (sigmaDiagnosis === null) return false;
  if (simulated === null) return false;

  const gapExpected = measured - (simulated + offset);
  const gapNormalized = gapExpected / sigmaDiagnosis;

  return Math.abs(gapNormalized) > SIGMA_COUNT;
}

export default isSymptom;
